module.exports = __webpack_public_path__ + "static/media/iv_lock_in.e90218bd.svg";